import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Table, Tooltip} from 'reactstrap';
import Pagination from 'react-js-pagination';
import { LoaderLista, LoaderMini } from '~/components/Loaders';
import { FiltroGeral } from '~/components/Filtros/FiltroGeral';
import { symbolPriceFormatter } from '~/helpers/price';
import { color } from '~/assets/styles/colors';
import setaBaixa from '~/assets/img/iconExtrato/setaBaixa.svg';
import setaCima from '~/assets/img/iconExtrato/setaCima.svg';
import moment from 'moment';
import {
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
	CloudDownloadOutlined,
	Clear,
} from '@mui/icons-material';
import { RiErrorWarningLine } from 'react-icons/ri';
import { PGMContext } from '~/context/PGMContext';
import { ContainerExtrato, ImgMontante, TbodyExtrato, TdExtrato, TextClick, TheadExtrato, ThExtrato, TrExtrato } from './styles';
import {
	CardSimplesDistribuidor,
} from '../../../components/ExtratoData/ExtratoSimples';

export default function ExtratoDistribuidor(props) {
	const { user, isMobile } = props;

	const {
		loadingCreditos,
		setLoadingCreditos,
		dataCredito,
		total,
		getMeusCreditos,
		totalItemsCredito,
		getExportMeusCreditos,
		loaderDownload,
	} = useContext(PGMContext);

	const [tooltipDescricao, setTooltipDescricao] = useState(null);
	const [dataRange, setDataRange] = useState({
		dateInit: '',
		dateEnd: '',
	})
	const [params, setParams] = useState({
		dateInit: moment().format('YYYY-MM-DD'),
		dateEnd: moment().format('YYYY-MM-DD'),
	});
	const [pagina, setPagina] = useState(1);

	function handlerPagination(page) {
		setPagina(page);
		getMeusCreditos(params, page);
	}

	useEffect(() => {
		getMeusCreditos(params, 1);
	}, [params]);


	const toggleTooltip = (itemId) => {
		setTooltipDescricao(tooltipDescricao === itemId ? null : itemId);
	};

	function handlerLimparFiltro() {
		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setPagina(1);
	}

	function extrairData() {
		getExportMeusCreditos(params)
	}

	return (
		<ContainerExtrato fluid>
			<FiltroGeral
				setLoading={setLoadingCreditos}
				setParams={setParams}
				setPagina={setPagina}
				dataRange={dataRange}
				showPaginaGrupo={false}
				setDataRange={setDataRange}
				nomeTela="Meus_Créditos"
			>
				<button
					style={{ all: 'unset', cursor: 'pointer', color: '#333333', float: 'right' }}
					type='button'
					onClick={() => handlerLimparFiltro()}>
					<Clear style={{ color: '#0AD6EA' }} />
					Limpar Filtros
				</button>
				{!loaderDownload ? (
					<TextClick
						style={{ all: 'unset', cursor: 'pointer', paddingRight: 10, color: '#333333', float: 'right' }}
						onClick={() => extrairData()}
						tabIndex="0"
						role="button"
					>
						<CloudDownloadOutlined className="mr-1" style={{ color: '#0AD6EA' }} />
						Fazer Download
					</TextClick>
				) : (
					<TextClick
						style={{ all: 'unset', cursor: 'pointer', paddingRight: 10, color: '#333333', float: 'right' }}
						tabIndex="0"
						role="button"
					>
						<LoaderMini />
					</TextClick>

				)}
			</FiltroGeral>

			{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria'  ?
				<CardSimplesDistribuidor
					total={{creditados: total.creditados, debitados: total.debitados, credito: total.credito}}
					user={user}
					extratos={dataCredito}
					loadingExtrato={loadingCreditos}
				/>
				:
				<></>
			}

			<Row className="mt-5">
				<Col>
					<LoaderLista loading={loadingCreditos} lista={dataCredito}>
						<Table id="test-table-xls-button" responsive>
							<TheadExtrato>
								<TrExtrato>
									<>
										<ThExtrato>Dt Lançamento</ThExtrato>
										<ThExtrato>Motivo</ThExtrato>
										<ThExtrato>Nº Documento</ThExtrato>

										<ThExtrato style={{ textAlign: 'left', paddingLeft: 22 }}>Origem</ThExtrato>
										{user.dados.cargo.toLowerCase() === '' ? <ThExtrato>Venda</ThExtrato> : <></>}
										<ThExtrato>V. Bruto</ThExtrato>
										<ThExtrato>Cred. Gerado</ThExtrato>
										<ThExtrato>Tipo</ThExtrato>
										<ThExtrato>Valores</ThExtrato>
									</>
								</TrExtrato>
							</TheadExtrato>
							<TbodyExtrato>
								{dataCredito.length > 0 && dataCredito.map((item, index) => {
									return (
										<>
											<TrExtrato key={`${item.numero_documento}-${index}`}>
												<TdExtrato>
													{item.data_lancamento ? item.data_lancamento.split(" ")[0] : ''}
												</TdExtrato>
												<TdExtrato>
													<p style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
													{item.descricao_rastreamento ? item.descricao_rastreamento  : "" }
													{
														(item.ajuste_descricao) && (
															<div>

																<p id={`Tooltip-${index}`} style={{marginTop: "10px",paddingLeft: "10px", color: color.red}}>
																	<RiErrorWarningLine />
																</p>
																<Tooltip
																	placement="top"
																	isOpen={tooltipDescricao === index}
																	target={`Tooltip-${index}`}
																	toggle={() =>  toggleTooltip(index)}
																>
																	{`${item.ajuste_descricao}`}
																</Tooltip>
															</div>
														)
													}
													</p>


												</TdExtrato>
												<TdExtrato>{item.documento}</TdExtrato>
												<TdExtrato style={{ textAlign: 'left' }}>{  item.tipo === 'CR' ? (item.lojista_nome  || '') : (item.distribuidor_nome || '')}</TdExtrato>
												{user.dados.cargo.toLowerCase() === '' ?
													<TdExtrato>
														{item.tipo === 'CR' ? symbolPriceFormatter(item.venda) : '-'}
													</TdExtrato> : <></>}
												<TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.bruto) : '-'}</TdExtrato>
												{/* <TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.taxa) : '-'}</TdExtrato>
									<TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.liquido) : '-'}</TdExtrato> */}
												<TdExtrato>{item.tipo === 'CR' ? symbolPriceFormatter(item.credito) : '-'}</TdExtrato>
												<TdExtrato>{item.tipo === 'CR' || item.credito > 0  ? 'Crédito' : 'Débito'}</TdExtrato>
												<TdExtrato style={{ color:  item.tipo === 'CR' || item.credito > 0 ? color.green : color.red }}>
														<>
															{item.tipo === 'CR' || item.credito > 0 ?
																<ImgMontante
																	alt="setaCima"
																	width="15"
																	src={setaCima}
																/> :
																<ImgMontante
																	alt="setaBaixa"
																	width="15"
																	src={setaBaixa}
																/>}
															{symbolPriceFormatter(item.credito)}
														</>
												</TdExtrato>
											</TrExtrato>
										</>
									);
								})}
							</TbodyExtrato>
						</Table>
						<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
							<Pagination
								activePage={pagina}
								totalItemsCount={totalItemsCredito}
								itemsCountPerPage={10}
								onChange={(page) => handlerPagination(page)}
								prevPageText={<ChevronLeftOutlined />}
								nextPageText={<ChevronRightOutlined />}
								firstPageText={<FirstPageOutlined />}
								lastPageText={<LastPageOutlined />}
							/>
						</div>
					</LoaderLista>
				</Col>
			</Row>
		</ContainerExtrato>
	);
}
